import { useState } from "react";
import { BiChevronDown } from "react-icons/bi";

import s from "./Accordion.module.css";

// Generic, presentation-only accordion. Each item's `content` is rendered ONLY
// while expanded, so data-fetching panels stay idle until opened. Kept fully
// decoupled from its content so the same panels can be shown elsewhere (e.g. a
// modal) without touching this component.
export const Accordion = ({
  items,
  allowMultiple = true,
  defaultOpenIds = [],
  className = "",
}) => {
  const [openIds, setOpenIds] = useState(() => new Set(defaultOpenIds));

  const toggle = (id) => {
    setOpenIds((prev) => {
      const next = new Set(allowMultiple ? prev : []);

      if (prev.has(id)) {
        next.delete(id);
      } else {
        next.add(id);
      }

      return next;
    });
  };

  return (
    <div className={`${s.accordion} ${className}`} data-testid="accordion">
      {items.map((item) => {
        const isOpen = openIds.has(item.id);

        return (
          <div
            key={item.id}
            className={s.item}
            data-testid={`accordion-item-${item.id}`}
          >
            <button
              type="button"
              className={s.header}
              aria-expanded={isOpen}
              onClick={() => toggle(item.id)}
              data-testid={`accordion-trigger-${item.id}`}
            >
              <span className={s.title}>{item.title}</span>
              <BiChevronDown
                className={`${s.chevron} ${isOpen ? s.chevronOpen : ""}`}
              />
            </button>
            {!!isOpen && (
              <div
                className={s.content}
                data-testid={`accordion-content-${item.id}`}
              >
                {item.content}
              </div>
            )}
          </div>
        );
      })}
    </div>
  );
};
